import React from 'react';
import PropTypes from 'prop-types';

const LiftLine = ({ x1, y1, x2, y2, color }) => (
	<line
		x1={x1} y1={y1} x2={x2} y2={y2}
		id="Line" stroke={color} strokeWidth="3" strokeLinecap="round"
		strokeDasharray="6"
		className="animated"
	/>
);

LiftLine.propTypes = {
	x1: PropTypes.string,
	y1: PropTypes.string,
	x2: PropTypes.string,
	y2: PropTypes.string,
	color: PropTypes.string
};

export default LiftLine;
